<template>
  <div>
    <main v-if="items">
      <molecule-modification-alert-detail
        :mode="mode"
        :alertData="alertData"
        :isValidateTrigger="isValidateTrigger"
        :canUpdate="hasUpdatePermission"
        @alertDetail="alertDetailChange"
        @clickDelete="clickDelete"
        @onErrorValidation="onErrorAlertDetailValidation"
      ></molecule-modification-alert-detail>

      <molecule-alert-notification
        :notificationData="notificationData"
        :isValidateTrigger="isValidateTrigger"
        :canUpdate="hasUpdatePermission"
        @alertNotification="alertNotificationChange"
        class="organism-alert-modification_alert-notification"
      ></molecule-alert-notification>

      <div class="card__alert-selection-table">
        <label class="card__alert-selection-table--topic">Select Server</label>
        <molecule-alert-selection-table
          v-model="items"
          :canUpdate="hasUpdatePermission"
        ></molecule-alert-selection-table>
        <section class="container__footer">
          <span class="text--entries text-secondary">
            Showing {{ items.length }} entries
          </span>
          <div
            v-if="isValidateTrigger && validateResourceEmptyValue && hasUpdatePermission"
            class="error-message_container"
          >
            <feather-icon icon="AlertCircleIcon" stroke="#ea5455"></feather-icon
            ><label class="error-message-style"
              >Please select at least 1 resource</label
            >
          </div>
        </section>
      </div>
      <section v-if="mode === 'create' && hasUpdatePermission" class="button__container">
        <atom-button
          buttonId="button-create-alert"
          :isDisable="isDisableButton"
          @click="clickApply"
          >Create New Alert</atom-button
        >
        <atom-button
          buttonId="button-cancel-alert"
          buttonStyle="border"
          buttonColor="secondary"
          @click="clickCancel"
          class="ml-1"
          >Cancel</atom-button
        >
      </section>
      <section v-else class="button__container--delete">
        <div v-if="hasUpdatePermission" class="delete--button">
          <atom-button
            buttonId="button-delete-alert"
            :styleInButton="deleteButtonStyle"
            @click="clickDelete"
            ><feather-icon
              icon="Trash2Icon"
              class="delete__icon--style"
            />Delete</atom-button
          >
        </div>
        <div v-if="hasUpdatePermission" class="save--button d-flex">
          <atom-button
            buttonId="button-edit-alert"
            @click="clickApply"
            :isDisable="isDisableButton"
            >Save Changes</atom-button
          >
          <atom-button
            buttonId="button-cancel-alert"
            buttonStyle="border"
            buttonColor="secondary"
            @click="clickCancel"
            class="ml-1"
            >Cancel</atom-button
          >
        </div>
      </section>
      <footer style="height: 28px"></footer>
    </main>

    <molecule-modal-dialog
      modalId="modal-confirm-apply-alert"
      :isTextCenter="true"
      :textTitle="`Do you want to ${
        mode === 'create' ? 'create alert\n' : 'save changes\nfor'
      } “${alertDetail.alertName}”?`"
      :buttonTextLeft="`${mode === 'create' ? 'Confirm' : 'Yes'}`"
      :buttonTextRight="`${mode === 'create' ? 'Cancel' : 'No'}`"
      @clickButtonLeft="clickConfirmApply"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-cancel-alert"
      :isTextCenter="true"
      :textTitle="`Do you want to leave\nwithout finishing?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmCancel"
    >
    </molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-delete-alert"
      icon="AlertCircleIcon"
      :isTextCenter="true"
      textTitle="Do you want to delete?"
      textSubtitle="You won’t be able to revert this!"
      buttonTextLeft="Delete"
      buttonTextRight="Cancel"
      buttonColorLeft="danger"
      @clickButtonLeft="clickConfirmDelete"
    >
    </molecule-modal-dialog>
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import MoleculeAlertNotification from "@/components/molecules/serverManagementModule/alert/MoleculeAlertNotification.vue"
import MoleculeAlertSelectionTable from "@/components/molecules/serverManagementModule/alert/MoleculeAlertSelectionTable.vue"
import MoleculeModificationAlertDetail from "@/components/molecules/serverManagementModule/alert/MoleculeModificationAlertDetail.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"
export default {
  components: {
    MoleculeModificationAlertDetail,
    MoleculeAlertNotification,
    MoleculeAlertSelectionTable,
    AtomButton,
    MoleculeModalDialog,
  },
  name: "OrganismAlertModification",
  props: {
    mode: {
      type: String,
      required: true,
    },
    alertData: {
      type: Object,
      required: true,
    },
    notificationData: {
      type: Object,
      required: true,
    },
    equipmentData: {
      type: Array,
      required: true,
    },
  },
  emits: ["createAlert", "editAlert", "deleteAlert"],
  mixins: [mixinsUser],
  data() {
    return {
      deleteButtonStyle:
        "background-color: #F6E4E4 !important;color: #EA5455 !important; border-color: #F6E4E4 !important",
      alertDetail: {},
      alertNotification: {},
      items: null,
      modalId: "",
      initialCheck: {
        alertData: true,
        notificationData: true,
        equipmentData: true,
      },
      firstStateAlertData: {},
      firstStateNotificationData: {},
      firstStateEquipmentData: [],
      isValidateTrigger: false,
      isErrorOnAlertDetail: false,
    }
  },
  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SMS.ALERT_WRITE)
    },
    disableSaveChangesButtonValue() {
      if (this.isEmpty(this.alertDetail.alertName)) return true
      else if (this.validateEmptyAlertDetailValue) return true
      else if (this.validateEmptyAlertNotificationValue) return true
      else if (this.validateResourceEmptyValue) return true
      else if (this.validateNotChangeValue) return true
      return false
    },
    validateEmptyAlertDetailValue() {
      if (this.alertDetail.alertEnableThreshold) {
        return (
          this.isEmpty(this.alertDetail.intervalThreshold) ||
          this.isEmpty(this.alertDetail.maximumAlertCount)
        )
      }
      return false
    },
    validateEmptyAlertNotificationValue() {
      const alertNotificationEmailValue = this.alertNotification.email
        ? JSON.parse(JSON.stringify(this.alertNotification.email))
        : null
      const alertNotificationSmsValue = this.alertNotification.sms
        ? JSON.parse(JSON.stringify(this.alertNotification.sms))
        : null
      const alertNotificationLineValue = this.alertNotification.line
        ? JSON.parse(JSON.stringify(this.alertNotification.line))
        : null
      return (
        alertNotificationEmailValue?.length === 0 &&
        alertNotificationSmsValue?.length === 0 &&
        alertNotificationLineValue?.length === 0
      )
    },
    validateResourceEmptyValue() {
      const resourceData = JSON.parse(JSON.stringify(this.items))
      const isResourceDataNotSelect = resourceData.every(
        (resource) =>
          !resource.cpu.isSelect &&
          !resource.memory.isSelect &&
          !resource.storage.isSelect
      )
      return isResourceDataNotSelect
    },
    validateNotChangeValue() {
      const isAlertDetailChange = this.validateAlertDetailChangeValue
      const isNotificationChange = this.validateNotificationChangeValue
      const isEquipmentChange = this.validateEquipmentChangeValue
      return !isAlertDetailChange && !isNotificationChange && !isEquipmentChange
    },
    validateAlertDetailChangeValue() {
      return (
        JSON.stringify(this.firstStateAlertData) !==
        JSON.stringify(this.alertDetail)
      )
    },
    validateNotificationChangeValue() {
      return (
        JSON.stringify(this.firstStateNotificationData) !==
        JSON.stringify(this.notificationData)
      )
    },
    validateEquipmentChangeValue() {
      const itemsWithoutIsCheckField = JSON.parse(JSON.stringify(this.items))
      itemsWithoutIsCheckField.forEach((item) => this.$delete(item, "isCheck"))
      return (
        JSON.stringify(this.firstStateEquipmentData) !==
        JSON.stringify(itemsWithoutIsCheckField)
      )
    },
    isDisableButton() {
      if (!this.isValidateTrigger) return false
      else {
        return this.disableSaveChangesButtonValue || this.isErrorOnAlertDetail
      }
    },
  },
  watch: {
    alertData: {
      deep: true,
      handler() {
        this.saveFirstStateData()
      },
    },
    notificationData: {
      deep: true,
      handler() {
        this.saveFirstStateData()
      },
    },
    items: {
      deep: true,
      handler() {
        this.saveFirstStateData()
      },
    },
  },
  mounted() {
    this.items = this.equipmentData
    this.saveFirstStateData()
    if (this.mode === "edit") this.isValidateTrigger = true
  },
  methods: {
    saveFirstStateData() {
      if (this.initialCheck.alertData && Object.keys(this.alertData).length) {
        this.firstStateAlertData = JSON.parse(JSON.stringify(this.alertData))
        this.initialCheck.alertData = false
      }
      if (
        this.initialCheck.notificationData &&
        Object.keys(this.notificationData).length
      ) {
        this.firstStateNotificationData = JSON.parse(
          JSON.stringify(this.notificationData)
        )
        this.initialCheck.notificationData = false
      }
      if (this.initialCheck.equipmentData && this.items.length > 0) {
        this.firstStateEquipmentData = JSON.parse(JSON.stringify(this.items))
        this.initialCheck.equipmentData = false
      }
    },

    alertDetailChange(alertDetail) {
      this.alertDetail = alertDetail
    },
    alertNotificationChange(alertNotification) {
      this.alertNotification = alertNotification
    },
    clickApply() {
      this.isValidateTrigger = true
      if (!this.isDisableButton) {
        this.modalId = "modal-confirm-apply-alert"
        this.$bvModal.show(this.modalId)
      }
    },
    clickConfirmApply() {
      this.closeModal()
      let request = {
        alertName: this.alertDetail.alertName,
        alertDescription: this.alertDetail.alertDescription,
        alertSMSGatewayPath: this.alertDetail.alertGateway,
        alertEnable: this.alertDetail.alertEnable,
        alertThresholdEnable: this.alertDetail.alertEnableThreshold,
        alertThresholdInterval: this.alertDetail.intervalThreshold,
        alertMaxEventCount: this.alertDetail.maximumAlertCount,
        alertEmails: this.alertNotification.email.map(
          (email) => email.alertEmailAddress
        ),
        alertSmses: this.alertNotification.sms,
        alertLines: this.alertNotification.line,
        alertEquipments: [],
      }
      this.items.forEach((item) => {
        if (
          item.cpu.isSelect ||
          item.memory.isSelect ||
          item.storage.isSelect
        ) {
          request.alertEquipments.push({
            equipmentId: item.id,
            equipmentName: item.nameServer,
            resourceType: {
              cpu: {
                policyEnable: item.cpu.isDisable,
                alertEnable: item.cpu.isSelect,
                warningThreshold: item.cpu.warningValue,
                criticalThreshold: item.cpu.criticalValue,
              },
              memory: {
                policyEnable: item.memory.isDisable,
                alertEnable: item.memory.isSelect,
                warningThreshold: item.memory.warningValue,
                criticalThreshold: item.memory.criticalValue,
              },
              storage: {
                policyEnable: item.storage.isDisable,
                alertEnable: item.storage.isSelect,
                warningThreshold: item.storage.warningValue,
                criticalThreshold: item.storage.criticalValue,
              },
            },
          })
        }
      })

      if (this.mode === "create") {
        this.$emit("createAlert", request)
      } else {
        this.$emit("editAlert", request)
      }
    },

    // cancel
    clickCancel() {
      if (!this.validateNotChangeValue) {
        this.modalId = "modal-confirm-cancel-alert"
        this.$bvModal.show(this.modalId)
      } else {
        this.$router.push("/server-management/alert")
      }
    },
    clickConfirmCancel() {
      this.closeModal()
      this.$router.push("/server-management/alert")
    },

    // delete
    clickDelete() {
      this.modalId = "modal-confirm-delete-alert"
      this.$bvModal.show(this.modalId)
    },
    clickConfirmDelete() {
      this.closeModal()
      this.$emit("deleteAlert")
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    // validate empty
    isEmpty(word) {
      if (word === "") return true
      else return false
    },

    onErrorAlertDetailValidation(isError) {
      this.isErrorOnAlertDetail = isError
    },
  },
}
</script>

<style lang="scss" scoped>

.button__container--delete .delete--button ::v-deep { 
  .btn-primary:hover:not(.disabled):not(:disabled){
    box-shadow: none;
  }
}

.organism-alert-modification_alert-notification {
  margin: 10px 0 10px 0;
}

.card__alert-selection-table {
  overflow: hidden;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.card__alert-selection-table--topic {
  font-weight: 500;
  font-size: 18px;
  padding-left: 23px;
  padding-top: 20px;
  margin-bottom: 16px;
}

.container__footer {
  padding: 1.5rem;
}

.text--entries {
  padding-left: 10px;
  font-size: 14px;
}

.button__container {
  display: flex;
  justify-content: flex-end;
  margin-top: 33px;
}

.button__container--delete {
  display: flex;
  justify-content: flex-end;
  margin-top: 33px;
}

.delete__icon--style {
  margin-right: 5px;
}

.delete--button {
  display: none;
}

.error-message_container {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.error-message-style {
  margin: 0;
  padding-left: 5px;
  font-size: 12px;
  color: #ea5455;
}

@media screen and (min-width: 768px) {
  .delete--button {
    display: flex;
  }
  .button__container--delete {
    display: flex;
    justify-content: space-between;
  }
}
</style>
